import React, { useState } from 'react';
import CountdownTimer from "../../../../components/CountdownTimer";

const SpecialOfferBannerWidget = ({selectedTemplate,countdownTimerTabData}) => {
    const [isCountdownTimerPopupOpen, setIsCountdownTimerPopupOpen] = useState(true);
                        
    // Function to toggle the popup and show it again after 4 seconds if hidden
    const toggleCountdownTimerPopup = () => {
        setIsCountdownTimerPopupOpen(false); // Hide the popup

        // Show popup again after 4 seconds
        setTimeout(() => {
            setIsCountdownTimerPopupOpen(true);
        }, 2000);
    };

    const labelDisplaysCount = countdownTimerTabData.timer_counters_labels_displays_count || [];

    //Convert time
    const convertTo24HourFormat = (time12h) => {
        const [time, modifier] = time12h.split(" ");
        let [hours, minutes] = time.split(":");
      
        hours = parseInt(hours, 10);
      
        if (modifier === "AM") {
          if (hours === 12) hours = 0;
        } else if (modifier === "PM") {
          if (hours !== 12) hours += 12;
        }
      
        return `${hours.toString().padStart(2, "0")}:${minutes}:00`;
    };

    return (
        <>
            <div className={`upgadeify countdown-timer-app-special-offer-banner-template ${countdownTimerTabData.timer_position_type} ${countdownTimerTabData.is_website_frontend}`}>
                <>
                {isCountdownTimerPopupOpen && (
                    <div className="spacial-saction" style={{
                            backgroundColor: countdownTimerTabData.appearance_colors_background_color,      
                        }}>
                       <div className='spacial-saction_main'>
                       <div className={`spacial-saction-inner`}>
                            <div className="text-box-black-firday">
                                <span style={{
                        color: countdownTimerTabData.appearance_colors_message_color,
                        fontSize: countdownTimerTabData.appearance_message_font_size,
                    }}>{ countdownTimerTabData.timer_message_before_timer }</span>
                            </div>
                            <div className="time-box-black-firday">
                                {/* Show All (Days, Hours, Minutes, Seconds) */}
                                <CountdownTimer
                                    startDate={`${countdownTimerTabData.timer_start_date}T${convertTo24HourFormat(countdownTimerTabData.timer_start_time)}`}
                                    endDate={`${countdownTimerTabData.timer_end_date}T${convertTo24HourFormat(countdownTimerTabData.timer_end_time)}`}
                                    showDays={labelDisplaysCount.includes("Days") === true}
                                    showHours={labelDisplaysCount.includes("Hours") === true}
                                    showMinutes={labelDisplaysCount.includes("Minutes") === true}
                                    showSeconds={labelDisplaysCount.includes("Seconds") === true}
                                    countdownTimerTabData={countdownTimerTabData}
                                    selectedTemplate={selectedTemplate}
                                />
                            </div>
                            {Number(countdownTimerTabData.button_is_show_button) === 1 && (
                                <>
                                    <div className="button-box-black-firday">
                                        <a  style={{
                                                backgroundColor: countdownTimerTabData.appearance_colors_button_color,
                                                padding:
                                                countdownTimerTabData.appearance_button_size / 2.1 + "px " +
                                                countdownTimerTabData.appearance_button_size + "px", 
                                                fontSize: countdownTimerTabData.appearance_button_size / 1.2 + "px",      
                                            }}
                                            href={countdownTimerTabData.button_link}
                                            target={Number(countdownTimerTabData.button_is_open_link_in_new_tab) === 1 ? "_blank" : "_self"}
                                            rel={Number(countdownTimerTabData.button_is_open_link_in_new_tab) === 1 ? "noopener noreferrer" : undefined}
                                            >
                                            {countdownTimerTabData.button_text}
                                        </a>
                                    </div>
                                </>
                            )}
                        </div>
                        {countdownTimerTabData.timer_position_type !== 'install_to_required_position' && (
                            <div className="close-buton-black-friday"><button onClick={toggleCountdownTimerPopup}><img src={`${process.env.PUBLIC_URL}/countdown-timer/templates/close.png`} alt="close" /></button></div>
                        )}
                       </div>
                    </div>
                    )}
                </>
            </div>
        </>
    )};
export default SpecialOfferBannerWidget;